"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOYALTY_BARCODE_PREFIXES = exports.sanitizeBarcode = void 0;
const barcodeConfig = [
    { prefix: '%bus', strip: 3, use: 6 },
    { prefix: '%eli', strip: 4, use: 5 },
    { prefix: '%lsb', strip: 4, use: 6 },
    { prefix: '%lsbb', strip: 5, use: 6 },
    { prefix: '%lsg', strip: 4, use: 6 },
    { prefix: '%lsr', strip: 4, use: 6 },
    { prefix: '%mem', strip: 4, use: 5 },
    { prefix: '%rub', strip: 1, use: 8 },
];
const sanitizeBarcode = (barcode) => {
    const lowerBarcode = barcode.toLowerCase();
    for (const { prefix, strip, use } of barcodeConfig) {
        if (lowerBarcode.startsWith(prefix)) {
            return barcode.slice(strip, strip + use);
        }
    }
    return barcode;
};
exports.sanitizeBarcode = sanitizeBarcode;
exports.LOYALTY_BARCODE_PREFIXES = [
    ...barcodeConfig.map(c => c.prefix),
    'ly',
];
//# sourceMappingURL=barcodeHelper.js.map